import React from "react";
import { Helmet } from "react-helmet";
import { generateImageUrl } from "../../sanityConfig";
import SiteConfig from "../../../config"
const Head = ({ graphTags,post}) => {
    return (
        <Helmet>
            <html lang="en" />
            <title>{post?.title}</title>
            <meta property="og:site_name" content="Delicious Experiences Blog" />
            <meta property="og:title" content={post?.title} />
            <meta property="og:type" content="article" />
            <meta name="twitter:title" content={post?.title} />
            <meta property="og:description" content={graphTags?.openGraphDescription || post?.description} />
            <meta name="twitter:description" content={graphTags?.openGraphDescription || post?.description} />
            <meta property="og:image" content={generateImageUrl(graphTags?.openGraphImage?.asset).width(1200).url() || generateImageUrl(post?.socialImage?.asset).width(1200).url()} />
            <meta name="twitter:image" content={generateImageUrl(graphTags?.openGraphImage?.asset).width(1400).url() || generateImageUrl(post?.socialImage?.asset).width(1400).url()} />
            <meta name="twitter:card" content="summary" />
            <meta property="og:url" content={SiteConfig?.url+"/posts/"+post.slug.current} />
            <meta name="twittter:url" content={SiteConfig?.url+"/posts/"+post.slug.current}/>
            <meta property="og:article:tag" content={post?.tags?.toString() || ""} />
            <meta property="og:article:author" content={post?.author?.name || ""} />
        </Helmet>
    )
}
export default Head